module.exports = __webpack_public_path__ + "hair-model-desktop-627c4b.webp";